var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.chosenMedicalCertificate)?_c('medical-certificate-details-content',{attrs:{"id":_vm.chosenMedicalCertificate.id,"seafarer-id":_vm.seafarerId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }